export default "__VITE_ASSET__CJNmQfiQ__"